import React, { useState } from "react";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useSelector } from "react-redux";
import {
  getJobApplicationList,
} from "../../../../services/workspace/recruitment.service";
import { useNavigate } from "react-router-dom";

const items = [{ label: "Candidates", path: "" }];
const customCase = {
  0: {
    label: "Pending",
    color: "text-blue-600 text-sm",
    bg: "bg-blue-600",
  },
  1: {
    label: "Shortlisted",
    color: "text-green-600 text-sm",
    bg: "bg-green-600",
  },
  2: {
    label: "Scheduled",
    color: "text-indigo-600 text-sm",
    bg: "bg-indigo-600",
  },
  3: {
    label: "On Hold",
    color: "text-yellow-600 text-sm",
    bg: "bg-yellow-600",
  },
  4: {
    label: "Offered",
    color: "text-purple-600 text-sm",
    bg: "bg-purple-600",
  },
  5: {
    label: "Hired",
    color: "text-emerald-600 text-sm",
    bg: "bg-emerald-600",
  },
  6: {
    label: "Rejected",
    color: "text-red-600 text-sm",
    bg: "bg-red-600",
  },
};

const ManageCandidates = () => {
  const { limit } = useSelector((state) => state.global);
  const navigate = useNavigate();

  const [modal, setModal] = useState({
    show: false,
    title: "",
    message: "",
    actionType: null,
    item: null,
    loading: false,
    icon: null,
    confirmText: "Confirm",
    buttonVariant: "primary",
  });

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    handleSearchChange,
    handlePageChange,
    fetchData,
    sortingUIProps,
  } = useCommonFetch(getJobApplicationList, {
    dataPath: "jobApplication.data",
    totalPath: "jobApplication.meta.total",
    errorMessage: "Failed to fetch job Application!",
    debounceDelay: 500,
    customParams: {
      with: "jobOpening",
    },
    sortingOptions: [
      { label: "Candidate Name", field: "name" },
      { label: "Last Action Date", field: "updated_at" },
    ],
    sortingModule: "candidates",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,

    dataTransformer: (data) => {
      if (!Array.isArray(data)) return { data: [], action: {} };

      const transformedData = data.map((item) => ({
        ...item,
        id: { data: item.uuid, variant: "text" },
        name: { data: item.name || "-", variant: "text" },
        department: { data: item.department_id || "-", variant: "text" },
        vacancies: { data: item.no_of_vacancies || 0, variant: "number" },
        applied_for: { data: item.jobOpening?.title || "-", variant: "text" },
        experience_required: {
          data: `${item.minimum_experience ?? 0} - ${
            item.maximum_experience ?? 0
          } Years`,
          variant: "text",
        },
        location: { data: item.address || "-", variant: "text" },
        closing_date: {
          data:
            item.closing_date && item.closing_date !== "-"
              ? item.closing_date
              : "-",
          variant:
            item.closing_date && item.closing_date !== "-" ? "date" : "text",
        },
        created_at: {
          data:
            item.created_at && item.created_at !== "-" ? item.created_at : "-",
          variant:
            item.created_at && item.created_at !== "-" ? "date-time" : "text",
        },
        status: {
          data: item?.status,
          className: "",
          variant: "status",
          customCases: customCase, // assuming you already have this defined somewhere
        },
      }));

      const actionButton = {
        view: (item) =>
          navigate(`/recruitment/candidates/detail/${item.id.data}`),
      };

      return { data: transformedData, action: actionButton };
    },
  });

  const TableHeaderData = [
    { label: "Candidate Name", key: "name" },
    { label: "Phone Number", key: "phone_number" },
    { label: "Email", key: "email" },
    { label: "Applied For ", key: "applied_for" },
    { label: "Experience ", key: "experience" },
    { label: "Source", key: "hear_from" },
    { label: "Last Action Date", key: "updated_at" },
    { label: "Status", key: "status" },
  ];

  return (
    <>
      <div className="flex flex-col gap-2">
        <PageTableHeader
          isSearch
          shorting={true}
          onSearchChange={handleSearchChange}
          breadcrumbs={items}
          sortingModule="candidates"
          onSortingChange={sortingUIProps?.onSortingChange}
          sortingProps={sortingUIProps}
        />

        <div className="bg-white rounded-lg shadow-sm">
          <CommonTable
            TableHeaderData={TableHeaderData}
            tabledata={tableData.data || []}
            currentPage={currentPage}
            totalData={totalData}
            setCurrentPage={handlePageChange}
            loading={loading}
            action={tableData.action}
          />
        </div>
      </div>

      {/* <CommonModal
        show={modal.show}
        headerTitle={
          <div className="flex flex-col items-center gap-4">
            <span className="text-xl text-center font-semibold">{modal.title}</span>
          </div>
        }
        onClose={() => setModal({ show: false, item: null })}
        modalSize="md"
      >
        <div className="text-center space-y-6 py-4">
          <p className="text-gray-600 text-base">{modal.message}</p>

          <div className="flex justify-center gap-4 pt-4">
            <DefaultButton
              name="Cancel"
              variant="outline"
              size="md"
              onClick={() => setModal({ show: false, item: null })}
              disabled={modal.loading}
            />

            <DefaultButton
              name={modal.confirmText}
              variant={modal.buttonVariant}
              size="md"
              loading={modal.loading}
              onClick={handleStatusConfirm}
            />
          </div>
        </div>
      </CommonModal> */}
    </>
  );
};

export default ManageCandidates;
